// Replace with your request types
export const GET_USER = "GET_USER";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const UPDATE_CUSTOMER_DATA_REQUEST = "UPDATE_CUSTOMER_DATA_REQUEST";
export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGOUT_USER = "LOGOUT_USER";
export const EMAIL_LOGIN_REQUEST = "EMAIL_LOGIN_REQUEST";
export const EMAIL_OTP_REQUEST = "EMAIL_OTP_REQUEST";
export const EMAIL_LOGIN_LOADING = "EMAIL_LOGIN_LOADING";
